const siteSearchIndex = [
  {
    title: "All Pages",
    route: "/explorers",
    type: "page",
    keywords: ["all pages", "index", "explorers", "browse", "sitemap", "directory", "everything"]
  },
  {
    title: "Privacy Policy",
    route: "/privacy",
    type: "page",
    keywords: ["privacy", "policy", "account", "data", "delete account", "notes", "cookies"]
  },
  {
    title: "Genesis Explorer",
    route: "/genesis",
    type: "page",
    keywords: ["genesis", "creation", "fall", "flood", "abraham", "isaac", "jacob", "joseph", "patriarchs"]
  },
  {
    title: "Exodus Explorer",
    route: "/exodus",
    type: "page",
    keywords: ["exodus", "moses", "plagues", "red sea", "sinai", "pharaoh"]
  },
  {
    title: "Leviticus Explorer",
    route: "/leviticus",
    type: "page",
    keywords: ["leviticus", "offerings", "feasts", "clean", "unclean", "holiness", "priesthood"]
  },
  {
    title: "Numbers Explorer",
    route: "/numbers",
    type: "page",
    keywords: ["numbers", "spies", "korah", "meribah", "wilderness", "census", "moab", "balaam"]
  },
  {
    title: "Wilderness Journey Explorer",
    route: "/exodus-deuteronomy",
    type: "page",
    keywords: ["wilderness", "journey", "wanderings", "camp", "route", "deuteronomy"]
  },
  {
    title: "Joshua Explorer",
    route: "/joshua",
    type: "page",
    keywords: ["joshua", "jericho", "ai", "jordan", "conquest", "canaan"]
  },
  {
    title: "Judges Explorer",
    route: "/judges",
    type: "page",
    keywords: ["judges", "othniel", "ehud", "deborah", "barak", "gideon", "jephthah", "samson", "cycle", "oppression", "deliverance"]
  },
  {
    title: "United to Divided Kingdoms",
    route: "/1samuel-2chron",
    type: "page",
    keywords: ["samuel", "chronicles", "david", "saul", "solomon", "divided kingdom", "wars"]
  },
  {
    title: "Post Exile History",
    route: "/ezra-nehemiah-esther",
    type: "page",
    keywords: ["post exile", "ezra", "nehemiah", "return", "rebuild", "restoration"]
  },
  {
    title: "Job: A Guided Conversation",
    route: "/job",
    type: "page",
    keywords: ["job", "suffering", "debate", "friends", "god's response"]
  },
  {
    title: "Psalms Explorer",
    route: "/psalms",
    type: "page",
    keywords: ["psalms", "songs", "prayers", "wisdom", "praise", "lament", "thanksgiving", "trust in god", "kingship", "messiah", "deliverance", "justice", "judgment", "temple", "presence"]
  },
  {
    title: "Proverbs: Wisdom for Life",
    route: "/proverbs",
    type: "page",
    keywords: ["proverbs", "wisdom", "sayings", "guidance", "righteous living"]
  },
  {
    title: "Ecclesiastes: Finding Meaning in Life",
    route: "/ecclesiastes",
    type: "page",
    keywords: ["ecclesiastes", "meaning of life", "vanity", "wisdom", "time", "death"]
  },
  {
    title: "Song of Songs: A Celebration of Love",
    route: "/song-of-songs",
    type: "page",
    keywords: ["song of songs", "love", "desire", "poetry", "relationships"]
  },
  {
    title: "Major Prophets Explorer: Isaiah",
    route: "/isaiah",
    type: "page",
    keywords: ["major prophets", "isaiah", "jeremiah", "lamentations", "ezekiel", "timeline"]
  },
  {
    title: "Major Prophets Explorer: Jeremiah",
    route: "/jeremiah",
    type: "page",
    keywords: ["jeremiah", "lamentations", "major prophets", "new covenant", "babylon", "exile", "timeline"]
  },
  {
    title: "Major Prophets Explorer: Ezekiel",
    route: "/ezekiel",
    type: "page",
    keywords: ["ezekiel", "major prophets", "exile", "glory", "judgment", "restoration", "babylon", "timeline"]
  },
  {
    title: "Major Prophets Explorer: Daniel",
    route: "/daniel",
    type: "page",
    keywords: ["daniel", "prophecy", "visions", "dreams", "exile", "faithfulness"]
  },
  {
    title: "Minor Prophets Explorer",
    route: "/minor-prophets",
    type: "page",
    keywords: ["minor prophets", "hosea", "joel", "amos", "obadiah", "jonah", "micah", "nahum", "habakkuk", "zephaniah", "haggai", "zechariah", "malachi"]
  },
  {
    title: "A Walk Through the Gospels",
    route: "/walk-through-the-gospels",
    type: "page",
    keywords: ["gospels", "matthew", "mark", "luke", "john", "jesus", "miracles", "parables", "teachings"]
  },
  {
    title: "Church History through Acts",
    route: "/church-history",
    type: "page",
    keywords: ["church history", "acts", "apostolic age", "persecution", "councils", "doctrine", "church fathers"]
  },
  {
    title: "Church Letters",
    route: "/church-letters",
    type: "page",
    keywords: ["church letters", "paul", "general epistles", "historical context", "recipients", "key messages"]
  },
  {
    title: "Revelation",
    route: "/revelation",
    type: "page",
    keywords: ["revelation", "seven churches", "seals", "trumpets", "bowls"]
  },
  {
    title: "Who Ruled the Biblical Land?",
    route: "/who-ruled-the-biblical-land",
    type: "page",
    keywords: ["divided kingdoms", "babylonian empire", "persian empire", "greek empire", "roman empire", "herod", "biblical lands", "history"]
  },
  {
    title: "David → Alexander Timeline",
    route: "/david-alexander",
    type: "page",
    keywords: ["david", "alexander", "timeline", "judah", "israel", "babylon", "persia", "assyrian"]
  },
  {
    title: "Alexander → Early Church Timeline",
    route: "/alexander-earlychurch",
    type: "page",
    keywords: ["alexander", "early church", "rome", "herod", "apostles", "paul", "timeline"]
  },
  {
    title: "Early Church History",
    route: "/early-church-history",
    type: "page",
    keywords: ["early church history", "apostolic age", "persecution", "councils", "doctrine", "church fathers"]
  },
  {
    title: "Between the Testaments Timeline",
    route: "/between-the-testaments",
    type: "page",
    keywords: ["between the testaments", "rome", "herod", "apostles", "paul", "timeline"]
  },
  {
    title: "Second Temple leaders",
    route: "/second-temple-leaders",
    type: "page",
    keywords: ["second temple", "leaders", "high priests", "prophets", "political figures", "jewish history", "new testament"]
  },
  {
    title: "Adam to Noah Genealogy",
    route: "/adam-noah",
    type: "page",
    keywords: ["adam", "noah", "seth", "methuselah", "genealogy", "lineage"]
  },
  {
    title: "Shem's Lineage",
    route: "/shem-lineage",
    type: "page",
    keywords: ["shem", "arpachshad", "eber", "genealogy", "lineage"]
  },
  {
    title: "Ham's Lineage",
    route: "/ham-lineage",
    type: "page",
    keywords: ["ham", "cush", "mizraim", "put", "canaan", "genealogy"]
  },
  {
    title: "Japheth's Lineage",
    route: "/japheth-lineage",
    type: "page",
    keywords: ["japheth", "gomer", "magog", "genealogy"]
  },
  {
    title: "Abraham's Lineage",
    route: "/abraham-lineage",
    type: "page",
    keywords: ["abraham", "isaac", "ishmael", "terah", "genealogy"]
  },
  {
    title: "Haran's Lineage",
    route: "/haran-lineage",
    type: "page",
    keywords: ["haran", "lot", "milcah", "iscah", "genealogy"]
  },
  {
    title: "Nahor's Lineage",
    route: "/nahor-lineage",
    type: "page",
    keywords: ["nahor", "bethuel", "laban", "rebekah", "genealogy"]
  },
  {
    title: "Jacob's Lineage",
    route: "/jacob-lineage",
    type: "page",
    keywords: ["jacob", "israel", "12 tribes", "joseph", "judah", "genealogy"]
  },
  {
    title: "Esau's Lineage",
    route: "/esau-lineage",
    type: "page",
    keywords: ["esau", "edom", "edomites", "genealogy"]
  },
  {
    title: "Moses & Aaron's Lineage",
    route: "/moses-aaron",
    type: "page",
    keywords: ["moses", "aaron", "levites", "genealogy"]
  },
  {
    title: "Levitical Priesthood Line",
    route: "/levi-line",
    type: "page",
    keywords: ["levi", "priesthood", "genealogy", "lineage"]
  },
  {
    title: "King Saul's Lineage",
    route: "/saul-lineage",
    type: "page",
    keywords: ["saul", "jonathan", "abner", "michal", "first king", "monarchy", "lineage", "genealogy"]
  },
  {
    title: "Davidic Lineage Explorer",
    route: "/david-lineage",
    type: "page",
    keywords: ["david", "salmon", "rahab", "jesse", "solomon", "rehoboam", "abijah", "davidic", "lineage", "genealogy"]
  },
  {
    title: "Kings of Judah",
    route: "/kings-of-judah",
    type: "page",
    keywords: ["kings of judah", "judah", "royal succession", "david", "bathsheba", "solomon", "lineage", "genealogy"]
  },
  {
    title: "Women of the Bible",
    route: "/women-of-the-bible",
    type: "page",
    keywords: ["women", "bible", "genealogy", "stories", "faith"]
  },
  {
    title: "Early Church Fathers",
    route: "/early-church-fathers",
    type: "page",
    keywords: ["early church fathers", "church history", "fathers", "theology"]
  },
  {
    title: "Enemies of the Bible",
    route: "/enemies-of-the-bible",
    type: "page",
    keywords: ["enemies", "bible", "pharaoh", "goliath", "haman", "sennacherib", "pilate"]
  },
  {
    title: "Nations of the Bible",
    route: "/nations-of-the-bible",
    type: "page",
    keywords: ["nations", "bible", "egypt", "babylon", "persia", "rome", "canaan"]
  },
  {
    title: "Biblical Events Explorer",
    route: "/events",
    type: "page",
    keywords: ["biblical events", "explorer", "timeline", "filter", "search"]
  },
  {
    title: "The Preservation of Scripture",
    route: "/scripture-preservation",
    type: "page",
    keywords: ["preservation of scripture", "biblical text", "history", "translations", "manuscripts"]
  },
  {
    title: "Scripture Formation & Recognition",
    route: "/scripture-formation-recognition",
    type: "page",
    keywords: ["canon", "canon formation", "recognition", "scripture history", "canon lists", "church recognition", "doctrine"]
  }
];

export default siteSearchIndex;